/**
 * ปุ่มติดตามข่าวสาร (หน้าแรก)
 *
 * ดึงลิงก์ Telegram จาก BO (webPermission.contact.telegram) มาแทน href ที่
 * hardcoded ไว้ใน index.php ทำงานกับ <a data-tg-news> ทุกตัว
 *
 * webPermission ถูก store persist ลง localStorage (ดู stores/web.ts) — อ่านตรง
 * จาก localStorage เพื่อไม่ผูกกับ pinia แล้ว retry เผื่อ fetchPrefixPermission
 * ยังโหลดไม่เสร็จตอน DOMContentLoaded
 *
 * ถ้า BO ไม่มีลิงก์ / telegram.isActive = false → คง href เดิม (fallback)
 */

const RETRY_MS = [1000, 3000, 6000];

const readTelegramUrl = (): string | null => {
	try {
		const raw = localStorage.getItem('webPermission');
		if (!raw) return null;
		const perm = JSON.parse(raw) as {
			contact?: { telegram?: { url?: string; isActive?: boolean } };
		};
		const tg = perm?.contact?.telegram;
		if (tg?.isActive && typeof tg.url === 'string' && tg.url.trim() !== '') {
			return tg.url.trim();
		}
	} catch {
		// localStorage เสีย/parse ไม่ได้ → คง hardcoded
	}
	return null;
};

const applyTelegramLink = (): boolean => {
	const links = document.querySelectorAll<HTMLAnchorElement>('a[data-tg-news]');
	if (!links.length) return true; // ไม่มีปุ่มในหน้านี้ ไม่ต้องทำต่อ
	const url = readTelegramUrl();
	if (!url) return false; // ยังไม่มีค่า BO → คง hardcoded แล้วรอ retry
	links.forEach((a) => {
		a.href = url;
	});
	return true;
};

document.addEventListener('DOMContentLoaded', () => {
	if (applyTelegramLink()) return;
	// เผื่อ permission ยังโหลดไม่เสร็จ — ลองซ้ำเป็นช่วง ๆ แล้วหยุดเมื่อสำเร็จ
	for (const ms of RETRY_MS) {
		setTimeout(() => void applyTelegramLink(), ms);
	}
});
